import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillElectricityVerifyPayload {
  service_type: string;
  meter_no: string;
}

export interface BillElectricityVerifyResult {
  customer_name: string;
}

/**
 * Verify an electricity meter (returns the customer name) via the
 * provider-agnostic bills layer (/v3/bills).
 */
function useBillElectricityVerify(
  options?: MutationOptions<
    APIResponse<BillElectricityVerifyResult>,
    APIError,
    BillElectricityVerifyPayload
  >
) {
  const {
    mutate: verifyMeter,
    isLoading: verifyingMeter,
    isError: isVerifyError,
    error: verifyError,
    data: verifyResponse,
    reset: resetVerify,
  } = useMutation<
    APIResponse<BillElectricityVerifyResult>,
    APIError,
    BillElectricityVerifyPayload
  >(
    (payload) =>
      post(API_URL_V3 + "/bills/electricity/verify", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    verifyMeter,
    verifyingMeter,
    isVerifyError,
    verifyError,
    verifyResponse,
    resetVerify,
  };
}

export default useBillElectricityVerify;
